import React from 'react';
import { Link } from 'react-router-dom';
import { Gift, ArrowRight, Snowflake, Sparkles, Star, TreePine } from 'lucide-react';

export default function ChristmasBanner() {
  return (
    <section className="border-b border-border" aria-label="Jólagjafir hjá Vintage Treyjum">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-3 md:py-4">
        <div
          className="relative overflow-hidden border border-[#C8AA7C]/80 text-primary-foreground px-5 pt-6 pb-3 md:px-10 md:py-7"
          style={{ background: 'radial-gradient(ellipse at 50% 5%, #703843 0%, #542630 55%, #421b25 100%)' }}
        >
          {/* Þunnur gylltur rammi og hóflegt jólaskraut, innan við textasvæðið */}
          <div aria-hidden="true" className="pointer-events-none absolute inset-[5px] border border-[#D8BA87]/25" />
          <div aria-hidden="true" className="pointer-events-none absolute inset-x-0 top-0 h-[3px] bg-[#D0AD70]" />
          <div aria-hidden="true" className="pointer-events-none absolute left-3 top-3 md:left-6 md:top-5 opacity-45">
            <Snowflake className="h-5 w-5 md:h-7 md:w-7 text-[#E5CA9C]" strokeWidth={1.1} />
          </div>
          <div aria-hidden="true" className="pointer-events-none absolute right-3 top-3 md:right-5 md:top-4 opacity-45">
            <Star className="h-5 w-5 md:h-6 md:w-6 text-[#E5CA9C]" strokeWidth={1.2} />
          </div>
          <div aria-hidden="true" className="pointer-events-none absolute bottom-3 left-3 md:bottom-5 md:left-5 opacity-40">
            <Sparkles className="h-4 w-4 md:h-6 md:w-6 text-[#E5C898]" strokeWidth={1.2} />
          </div>

          <div className="relative z-10 flex flex-col md:flex-row gap-3 md:gap-10 md:items-center md:justify-between">
            <div className="min-w-0 text-center md:text-left">
              <div className="flex items-center justify-center md:justify-start gap-2 text-[#F0D29E] mb-3">
                <span aria-hidden="true" className="h-px w-5 bg-[#D4B67F]/80" />
                <span className="font-mono text-[9px] md:text-[10px] tracking-[0.15em] md:tracking-[0.23em] uppercase">Jólin hjá Vintage Treyjum</span>
                <span aria-hidden="true" className="h-px w-5 bg-[#D4B67F]/80" />
              </div>
              <h2 className="font-heading text-[1.7rem] sm:text-3xl md:text-4xl mb-2 leading-[1.15]">
                Jólagjafir fyrir fótboltaáhugafólk
              </h2>
              <p className="font-body text-[13px] md:text-base leading-relaxed text-[#F4EAE4]">
                Finndu vintage treyju frá uppáhaldsliðinu.
              </p>
            </div>
            <div className="flex flex-col md:flex-row items-center gap-3 md:gap-4 shrink-0">
              <Link to="/gjafahugmyndir" className="inline-flex shrink-0 items-center justify-center gap-2 bg-[#F5EFE5] text-[#4F2430] w-full md:w-auto px-4 md:px-5 py-3.5 md:py-4 font-mono text-[10px] uppercase tracking-[0.10em] md:tracking-[0.14em] hover:bg-white transition-colors">
                <Gift className="w-4 h-4 shrink-0" /> Skoða gjafahugmyndir <ArrowRight className="w-4 h-4 shrink-0" />
              </Link>
            </div>
          </div>
          {/* Tréð fær sérstaka línu undir efninu, svo það skarist aldrei við hnappinn. */}
          <div aria-hidden="true" className="relative z-10 mt-0 md:mt-3 flex items-center justify-end gap-2 md:gap-3 text-[#E7C78E]">
            <span className="h-px w-14 md:w-24 bg-[#D4B67F]/40" />
            <TreePine className="h-7 w-7 md:h-11 md:w-11 shrink-0" strokeWidth={1.3} />
          </div>
        </div>
      </div>
    </section>
  );
}
